import { useQuery } from "@tanstack/react-query";
import { mcpClient } from "../../lib/mcp-client";
import { queryKeys } from "../../lib/query-keys";
import type { ScopedPrompt } from "../../lib/types";

/**
 * Sprint 11 — prompts visible from a scope. Returns the prompts authored on the
 * scope node or any ancestor up to the workspace root (inheritance mirrors agent
 * instructions). Pass the cockpit node id; pass null/undefined for the
 * workspace-global (root) scope.
 *
 * Sprint 14g — pass `includeArchived` to surface archived prompts (drives the
 * "Show archived" chip in the Prompts panel).
 */
export function useListPromptsInScope(scopeNodeId: string | null | undefined, includeArchived?: boolean) {
  const scope = scopeNodeId ?? null;
  return useQuery<ScopedPrompt[]>({
    queryKey: [...queryKeys.promptsInScope(scope), includeArchived ?? false],
    queryFn: () => mcpClient.listPromptsInScope(scope ?? undefined, includeArchived),
    staleTime: 30_000,
  });
}
